module.exports = __webpack_public_path__ + "static/tshirts/tshirt-1-4995012523f54700932bcb0cf96de61d.jpg";